/**
 * =============================================================
 * AADHAV ACADEMY – ADMIN COURSE CATEGORY API
 * Role: Admin
 * Scope: Tenant-based Course Category Dropdown
 * Standard: Enterprise / MNC Level
 * =============================================================
 */

import { apiCall } from "../core/apiCall";

/* =============================================================
   BASE ENDPOINT
============================================================= */

const ADMIN_COURSE_CATEGORY_ENDPOINT =
  "/admin/courses/courseCategory.php";

/* =============================================================
   GET – Fetch Course Categories
============================================================= */

export const getAdminCourseCategories = async (
  options = {}
) => {
  try {
    const res = await apiCall(
      "GET",
      ADMIN_COURSE_CATEGORY_ENDPOINT,
      null,
      "Admin - Fetch Course Categories",
      options
    );

    if (!res || res.status !== true) {
      return {
        success: false,
        message:
          res?.message ||
          "Failed to fetch course categories",
        data: [],
      };
    }

    return {
      success: true,
      data: res.data || [],
    };
  } catch (error) {
    console.error(
      "Admin Fetch Course Categories Error:",
      error
    );

    return {
      success: false,
      message:
        error.message ||
        "Unexpected error occurred",
      data: [],
    };
  }
};